import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchContainerFiles(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/delivery_container/show_container/${organization_id}/fetch_container_files/${agro_exporter_process_id}`
    );
  },

  fetchContainer(organization_id, container_id) {
    return RequesterV1.get(
      `organization/production/delivery_container/show_container/${organization_id}/fetch_container/${container_id}`
    );
  },

  fetchContainerAttachments(organization_id, container_id) {
    return RequesterV1.get(
      `organization/production/delivery_container/show_container/${organization_id}/fetch_container_attachments/${container_id}`
    );
  },

  createContainerAttachment(
    organization_id,
    container_id,
    container_file_id,
    file
  ) {
    let formData = new FormData();
    formData.append("container_attachment[container_attach]", file || "");
    formData.append(
      "container_attachment[exporter_process_container_file_id]",
      container_file_id
    );
    return RequesterV1.post(
      `organization/production/delivery_container/show_container/${organization_id}/create_container_attachment/${container_id}`,
      formData
    );
  },

  destroyContainerAttachment(organization_id, container_attachment_id) {
    return RequesterV1.delete(
      `organization/production/delivery_container/show_container/${organization_id}/destroy_container_attachment/${container_attachment_id}`
    );
  },

  downloadContainerAttachment(organization_id, container_attachment_id) {
    return RequesterV1.get(
      `organization/production/delivery_container/show_container/${organization_id}/download_container_attachment/${container_attachment_id}`,
      { responseType: "blob" }
    );
  },

  fetchAgroExporterProcess(organization_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `organization/production/delivery_container/show_container/${organization_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  }
};
